import React from "react";
import "./Loader.scss";
var Loader = function () {
    return (React.createElement("div", { className: "loaderContainer" },
        React.createElement("div", { className: "loaderBody" })));
};
export default Loader;
